let dropDownLinks;
let windowWidth;

function init() {
    
    dropDownLinks = $('.list.list--footer a')
    windowWidth = document.body.clientWidth;
    
    InitFooterMenu();
    InitFooterForm();
    FooterDateUpdate();
}

function setTabIndexes() {
    if (document.body.clientWidth < 1025) {
        $(dropDownLinks).each((index, el) => {
            $(el).attr('tabindex', '-1');
        })
    }
}

function InitFooterMenu() {
    $(window).on("resize", function () {

        if (windowWidth !== document.body.clientWidth) {
            $('.footer__dropdown').removeClass('active');
            setTabIndexes();
        }
    });
    $('.js-dropdown-toggle').each(function (i) {
        // $('.footer__dropdown').removeClass('active');

        setTabIndexes();

        $(this).on('click', function (event) {
            event.preventDefault();
            $(dropDownLinks).each((index, el) => {
                $(el).attr('tabindex', '-1');
            })
            if ($(this).closest('.footer__dropdown').hasClass('active')) {
                $(this).closest('.footer__dropdown').removeClass('active');

                // console.log(links)
                $(this).closest('.footer__dropdown').attr('aria-expanded', true)
            } else if (!$(this).closest('.footer__dropdown').hasClass('active')) {
                $('.footer__dropdown').removeClass('active');
                const links = $(this).next().find('a');
                $(links).each((index, el) => $(el).attr('tabindex', '0'));

                $(this).closest('.footer__dropdown').addClass('active');
            }
        });
    });

    $('.js-foot-select').change(function () {
        window.open($(this).val(), '_blank');
    });
}


function InitFooterForm() {
    //Placeholder until we get form submission info
    var frm = $('#signup-container');
    var submitBtn = $('#signup-container .btn');
    frm.on("submit", function (e) {
        if (!e.detail || e.detail == 1) { // disables double clicks
            submitForm();
        }
        e.preventDefault();
        function submitForm() {
            let pardotForm = frm;

            if (window.FormData !== undefined) {
                var formData = new FormData(pardotForm[0]);
                let endpointUrl = pardotForm.attr("data-endpoint-url");

                $.ajax({
                    type: "POST",
                    url: endpointUrl,
                    dataType: 'json',
                    cache: false,
                    contentType: false,
                    data: formData,
                    processData: false,
                    beforeSend: function () {
                        // $('#submit').text('Submitting...');
                    },
                    complete: function (jqXHR, status) {
                        console.log(status);
                    },
                    success: function (result) {
                        if (result.IsResponseSaved) {
                            submitBtn.html('Submitted ✓');
                            window.dataLayer = window.dataLayer || [];
                            window.dataLayer.push({
                                'event': 'form_submit',
                                'form_type': 'email subscription'
                            });
                        } else {
                            alert("Error occurred submitting. Please try again.");
                        }
                    }
                });
            }
        }
    });
}

function FooterDateUpdate() {
    var d = new Date();
    $('.footer__copyright .year').html(d.getFullYear());
}

export {
    init
}
